var _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCreditOut = function SvgCreditOut(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6799 5.87611L17.0004 8.29619L14.6799 10.7163M17.0004 8.29619H11.4313H17.0004Z",
    stroke: "#2B788E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0.83066 1 1.50404 1.67338 1.50404 2.50404V15.496C1.50404 16.3266 0.83066 17 0 17",
    stroke: "#2B788E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70703 4.45093H6.91835M2.70703 13.2352H7.76563C8.79287 13.2352 9.62563 12.4025 9.62563 11.3752V7.58818M6.91835 4.45093H7.76562C8.79287 4.45093 9.62563 5.28368 9.62563 6.31093V7.58818M6.91835 4.45093C6.81808 5.3921 7.21916 7.3372 9.62563 7.58818",
    stroke: "#2B788E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21957 13.2354C7.1193 12.3988 7.46021 10.6001 9.62603 10.0981",
    stroke: "#2B788E",
    strokeWidth: 0.93
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70703 7.27441C3.70382 7.27441 4.51172 8.11763 4.51172 9.15723L4.50293 9.34961C4.41031 10.2986 3.64138 11.0391 2.70703 11.0391V10.2129C3.21524 10.2129 3.68625 9.77355 3.68652 9.15723C3.68652 8.57908 3.27248 8.15596 2.80176 8.10547L2.70703 8.10059V7.27441Z",
    fill: "#2B788E"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "assets/images/creditOut.svg";
export { ForwardRef as ReactComponent };